import React from 'react';
import cx from 'classnames';
import { Input } from '@mui/material';

/**
 * @typedef {object} MuiInputTextWithRemainingCharsOwnProps
 * @property {string} [value]
 * @property {string} [defaultValue]
 * @property {number} [minLength]
 * @property {number} maxLength
 * @property {boolean} [hideRemainingChars]
 * @property {boolean} [isInlineTable]
 */

/**
 * @typedef {MuiInputTextWithRemainingCharsOwnProps &
 *   React.ComponentProps<typeof Input>} MuiInputTextWithRemainingCharsProps
 */

/**
 * @type {React.ForwardRefExoticComponent<MuiInputTextWithRemainingCharsProps & React.RefAttributes<*>>}
 * @param {MuiInputTextWithRemainingCharsProps} props
 */
const MuiInputTextWithRemainingChars = React.forwardRef((props, ref) => {
  const {
    value,
    defaultValue,
    minLength,
    maxLength,
    isInlineTable = false,
    hideRemainingChars = false,
    ...inputProps
  } = props;

  const text = value || defaultValue || '';
  const textLength = text.length;

  return (
    <div
      data-testid='text-input-wrapper'
      className={cx('text-input-wrapper', { 'inline-table': isInlineTable })}>
      <Input
        inputRef={ref}
        {...inputProps}
        value={value}
        defaultValue={defaultValue}
        inputProps={{ minLength: minLength, maxLength: maxLength }}
      />
      {!hideRemainingChars && (
        <p className={cx('remaining-characters', { 'inline-table': isInlineTable })}>
          {textLength}/{maxLength}
        </p>
      )}
    </div>
  );
});

MuiInputTextWithRemainingChars.displayName = 'MuiInputTextWithRemainingChars';

export default MuiInputTextWithRemainingChars;
